import { useQuery } from "@tanstack/react-query";
import api from "../config/axiosConfig";

//Hook para cacheLoader
export const fetchTipoDocumento = async () => {
  const response = await api.get("/tipoDocumento");
  return response.data;
};

// Hook reutilizable con React Query
export const useTipoDocumento = () => {
  return useQuery({
    queryKey: ["tipoDocumento"],
    queryFn: fetchTipoDocumento,
    staleTime: 1000 * 60 * 60 * 24 * 7, // 7 días (igual que en CacheLoader.js)
    cacheTime: 1000 * 60 * 60 * 24 * 14, // 14 días (igual que en CacheLoader.js)
  });
};
